import AddOpdEntry from "../pages/opd/transaction/opdEntry/add";
import ListOpdEntry from "../pages/opd/transaction/opdEntry/list";
import EditOpdEntry from "../pages/opd/transaction/opdEntry/edit";
import ViewOpdEntry from "../pages/opd/transaction/opdEntry/view";

import AddOpdChargesEntry from "../pages/opd/transaction/opdChargesEntry/add";
import ListOpdChargesEntry from "../pages/opd/transaction/opdChargesEntry/list";
import EditOpdChargesEntry from "../pages/opd/transaction/opdChargesEntry/edit";

import AddOpdRefundEntry from "../pages/opd/transaction/opdRefundEntry/add";
import ListOpdRefundEntry from "../pages/opd/transaction/opdRefundEntry/list";
import EditOpdRefundEntry from "../pages/opd/transaction/opdRefundEntry/edit";

import AddOpdPrescriptionEntry from "../pages/opd/transaction/opdPrescriptionEntry/add";
import ListOpdPrescriptionEntry from "../pages/opd/transaction/opdPrescriptionEntry/list";
import EditOpdPrescriptionEntry from "../pages/opd/transaction/opdPrescriptionEntry/edit";

import ListPatientSearch from "../pages/opd/transaction/patientSearch/list";

import AddMedicalCertificateEntry from "../pages/opd/transaction/medicalCertificateEntry/add";
import ListMedicalCertificateEntry from "../pages/opd/transaction/medicalCertificateEntry/list";
import EditMedicalCertificateEntry from "../pages/opd/transaction/medicalCertificateEntry/edit";

import OpdRegistrationReport from "../pages/opd/reports/opdRegistrationReport";
import AreaWiseOpdRegistrationReport from "../pages/opd/reports/areaWiseOpdRegistrationReport";
import DepartmentWiseOpdRegistrationReport from "../pages/opd/reports/departmentWiseOpdRegistrationReport";
import CaseWiseOpdRegistrationReport from "../pages/opd/reports/caseWiseOpdRegistrationReport";
import ConsultantWiseOpdRegistrationReport from "../pages/opd/reports/consultantWiseOpdRegistrationReport";
import OpdChargesReport from "../pages/opd/reports/opdChargesReport";
import GroupWiseChargesReport from "../pages/opd/reports/groupWiseChargesReport";
import GenderWiseOpdRegistrationReport from "../pages/opd/reports/genderWiseOpdRegistrationReport";
import EmergencyStatisticsReport from "../pages/opd/reports/emergencyStatisticsReport";
import OpdSummaryReport from "../pages/opd/reports/opdSummaryReport";
import OpdRefundReport from "../pages/opd/reports/opdRefundReport";
import EstimateForTreatmentReport from "../pages/opd/reports/estimateForTreatmentReport";

export const opdTransactionRoutes = [
  {
    path: `/opd/transaction/opd-entry/add`,
    Component: <AddOpdEntry />,
    permission: "opdregistration.add"
  },
  {
    path: `/opd/transaction/opd-entry/list`,
    Component: <ListOpdEntry />,
    permission: "opdregistration.list"
  },
  {
    path: `/opd/transaction/opd-entry/edit/:id`,
    Component: <EditOpdEntry />,
    permission: "opdregistration.edit"
  },
  {
    path: `/opd/transaction/opd-entry/view/:id`,
    Component: <ViewOpdEntry />,
    permission: "opdregistration.view"
  },

  {
    path: `/opd/transaction/opd-charges-entry/add`,
    Component: <AddOpdChargesEntry />,
    permission: "opdcharges.add"
  },
  {
    path: `/opd/transaction/opd-charges-entry/list`,
    Component: <ListOpdChargesEntry />,
    permission: "opdcharges.list"
  },
  {
    path: `/opd/transaction/opd-charges-entry/edit/:id`,
    Component: <EditOpdChargesEntry />,
    permission: "opdcharges.edit"
  },

  {
    path: `/opd/transaction/opd-refund-entry/add`,
    Component: <AddOpdRefundEntry />,
    permission: "opdrefund.add"
  },
  {
    path: `/opd/transaction/opd-refund-entry/list`,
    Component: <ListOpdRefundEntry />,
    permission: "opdrefund.list"
  },
  {
    path: `/opd/transaction/opd-refund-entry/edit/:id`,
    Component: <EditOpdRefundEntry />,
    permission: "opdrefund.edit"
  },

  {
    path: `/opd/transaction/opd-prescription-entry/add`,
    Component: <AddOpdPrescriptionEntry />,
    permission: "opdprescription.add"
  },
  {
    path: `/opd/transaction/opd-prescription-entry/list`,
    Component: <ListOpdPrescriptionEntry />,
    permission: "opdprescription.list"
  },
  {
    path: `/opd/transaction/opd-prescription-entry/edit/:id`,
    Component: <EditOpdPrescriptionEntry />,
    permission: "opdprescription.edit"
  },

  {
    path: `/opd/transaction/patient-search/list`,
    Component: <ListPatientSearch />,
    permission: "patientsearch.list"
  },

  {
    path: `/opd/transaction/medical-certificate-entry/add`,
    Component: <AddMedicalCertificateEntry />,
    permission: "medicalcertificate.add"
  },
  {
    path: `/opd/transaction/medical-certificate-entry/list`,
    Component: <ListMedicalCertificateEntry />,
    permission: "medicalcertificate.list"
  },
  {
    path: `/opd/transaction/medical-certificate-entry/edit/:id`,
    Component: <EditMedicalCertificateEntry />,
    permission: "medicalcertificate.edit"
  }
];

export const opdReportRoutes = [
  {
    path: `/opd/reports/opd-registration-report`,
    Component: <OpdRegistrationReport />,
    permission: "opdregistrationreport"
  },
  {
    path: `/opd/reports/area-wise-opd-registration-report`,
    Component: <AreaWiseOpdRegistrationReport />,
    permission: "areawiseopdregistrationreport"
  },
  {
    path: `/opd/reports/department-wise-opd-registration-report`,
    Component: <DepartmentWiseOpdRegistrationReport />,
    permission: "departmentwiseopdregistrationreport"
  },
  {
    path: `/opd/reports/case-wise-opd-registration-report`,
    Component: <CaseWiseOpdRegistrationReport />,
    permission: "casewiseopdregistrationreport"
  },
  {
    path: `/opd/reports/consultant-wise-opd-registration-report`,
    Component: <ConsultantWiseOpdRegistrationReport />,
    permission: "consultantwiseopdregistrationreport"
  },
  {
    path: `/opd/reports/opd-charges-report`,
    Component: <OpdChargesReport />,
    permission: "opdchargesreport"
  },
  {
    path: `/opd/reports/group-wise-charges-report`,
    Component: <GroupWiseChargesReport />,
    permission: "groupwisechargesreport"
  },
  {
    path: `/opd/reports/gender-wise-opd-registration-report`,
    Component: <GenderWiseOpdRegistrationReport />,
    permission: "genderwiseopdregistrationreport"
  },
  {
    path: `/opd/reports/emergency-statistics-report`,
    Component: <EmergencyStatisticsReport />,
    permission: "emergencystatisticsreport"
  },
  {
    path: `/opd/reports/opd-summary-report`,
    Component: <OpdSummaryReport />,
    permission: "opdsummaryreport"
  },
  {
    path: `/opd/reports/opd-refund-report`,
    Component: <OpdRefundReport />,
    permission: "opdrefundreport"
  },
  {
    path: `/opd/reports/estimate-for-treatment-report`,
    Component: <EstimateForTreatmentReport />,
    permission: "estimatefortreatmentreport"
  }
];
